// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ColumnVariant1_wrapper__2CD4M","body":"ColumnVariant1_body__R0tPc","footer":"ColumnVariant1_footer__G8_wm"};